var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserLight = function SvgIconUserLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.066 8.634a3.267 3.267 0 1 0 0 6.533 3.267 3.267 0 0 0 0-6.533M11.333 11.9a4.733 4.733 0 1 1 9.467 0 4.733 4.733 0 0 1-9.467 0M7.333 21.633a3.123 3.123 0 0 1 3.133-3.133h11.2a3.123 3.123 0 0 1 3.133 3.133v3.6h-1.466v-3.6c0-.928-.738-1.666-1.667-1.666h-11.2c-.928 0-1.666.738-1.666 1.666v3.6H7.333z"
  }))));
};
export default SvgIconUserLight;